import EmberRouter from '@ember/routing/router';
import config from 'dummy/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('besluit-sample', { path: '/' });
  this.route('regulatory-statement-sample');
  this.route('snippet-edit-sample');
});
